import { render } from "./quiz3d.svg?vue&type=template&id=b6f3f840"
const script = {}
script.render = render

export default script